import langMap from '@/utils/language'
import store from '@/store'

export default {
  install(Vue) {
    // 定义全局方法
    Vue.prototype.$translate = function(key) {
      const language = store.state.app.language
      if(key === 'sync.robot'){
        console.log(langMap)
      }
      return langMap[key] ? langMap[key][language] : key
    }
  }
}
